import { React, useState, useEffect, useRef } from "react";
import { Link, useLocation, useHistory, useParams } from "react-router-dom";
import axios from "axios";
import { useSelector } from "react-redux";
import PropTypes from 'prop-types'
import AvatarGroup from "../LikeComment/AvatarGroup";
import LikeComment from "../LikeComment/LikeComment";
import Comment from "../LikeComment/Comment"
import { serverUrl, apiUrl } from '../Helpers/Config';
import moment from "moment";
import CommentInput from "../LikeComment/CommentInput";
import { htmlToText, trimString, getProfilePic, convertDate, tokenAuthorize, removeIframe, Loading, convertDateFormat } from "../Helpers/Common";
import { staticFiles } from "../Helpers/Static";
import { ActiveIconColor, BgComment, Card, TextGray, MenuItemCard, MenuItemDiv, ButtonCommonTopNew, CardNew } from "../../pages/Theme";
import ButtonCommon from "../Button/ButtonCommon";
import { makeStyles } from '@mui/styles';
import { Menu, MenuItem, Tooltip } from "@mui/material";
import MoreVertIcon from '@mui/icons-material/MoreVert';
import ThumbUpAltIcon from '@mui/icons-material/ThumbUpAlt';
import ThumbUpOffAltIcon from '@mui/icons-material/ThumbUpOffAlt';
import { FaRegCommentDots } from "react-icons/fa";
import { MdOutlinePublic } from "react-icons/md";
import { IoMdLock } from "react-icons/io";
import { LuSend } from "react-icons/lu";
import RichTextReadMore from "../Editor/RichTextReadMore";
import ChatInput from "../LikeComment/ChatInput";

import SortToggle from "../../components/Button/SortToggle";

const NO_IMAGE = staticFiles.noImage;

const PublicCardPostNew = ({ post, profile, tabId, isGuest, guestCode, profileTheme, isPublicProfileURL, src, ...props }) => {
    const location = useLocation()
    const history = useHistory()
    const { userId } = useParams();
    const userProfile = useSelector(state => state.auth.user);
    const userTheme = useSelector(state => state.auth.theme);
    const isDefaultTheme = useSelector(state => state.auth.isDefaultTheme);
    const [comment, setComment] = useState('')
    const [commentList, setCommentList] = useState([])
    const [currentIsLiked, setCurrentIsLiked] = useState(0)
    const [toggleComment, setToggleComment] = useState(false)
    const [loadingComments, setLoadingComments] = useState(false);
    const [offsetComments, setOffsetComments] = useState(0);
    const [hasMoreComments, setHasMoreComments] = useState(false);
    const [sortOrder, setSortOrder] = useState("desc");
    const [sortOrderInitial, setSortOrderInitial] = useState("desc");
    const [anchorEl, setAnchorEl] = useState(null);
    const [isPublic, setIsPublic] = useState(true);

    const open = Boolean(anchorEl);

    const useStyles = makeStyles((theme) => ({
        customMenu: {
            backgroundColor: isDefaultTheme == false && userTheme ? `${userTheme?.color3} !important` : 'white !important',
            width: '200px !important;'
        }
    }));

    const classes = useStyles();

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    useEffect(() => {
        if (post?.likes?.is_like) {
            setCurrentIsLiked(post.likes.is_like ? 1 : 0)
        } else {
            setCurrentIsLiked(0)
        }
    }, [post])

    useEffect(() => {
        let str = sortOrder
        if (localStorage.getItem("sortOrder") != undefined) {
            str = localStorage.getItem("sortOrder")
        }
        setSortOrder(str);
        setSortOrderInitial(str);
    }, [post.id]);

    const handleCommentClick = () => {
        setToggleComment(!toggleComment)
        let str = sortOrder
        if (localStorage.getItem("sortOrder") != undefined) {
            str = localStorage.getItem("sortOrder")
            setSortOrder(str)
        }
        if (!toggleComment === false) {
            setOffsetComments(0);
            setHasMoreComments(false);
            setSortOrderInitial(str);
            setCommentList([]);
        }
        if (!toggleComment === true) {
            setLoadingComments(true);
            getComments(offsetComments);
        }
    }

    const likePost = (isLiked) => {
        return axios.post(
            serverUrl.ReflectionPost + '/like',
            { reflection_id: post.id, like: isLiked }
        ).then(resp => {
            if (resp.status === 200) {
                getLikes()
                changeLike();
            }
        }).catch((err) => {
            tokenAuthorize(err?.response?.status);
            console.log(err)
        })
    }

    const changeLike = () => {
        return (axios.get(
            apiUrl + 'reflection/' + post.id
        ).then(res => {
            if (res.status === 200) {
                const like = parseInt(res.data.post.like)
                props.likePost && props.likePost(post.id, like)
                setCurrentIsLiked(like)
            }
        })
        )
    }

    const getLikes = () => {
        return axios.get(
            apiUrl + 'likes/' + post.id
        ).then(resp => {
            if (resp.status === 200) {
                let likesList = resp.data.results
            }
        }).catch(err => {
            tokenAuthorize(err?.response?.status);
            console.log(err)
        })
    }

    const getComments = (offset) => {
        return axios.get(
            apiUrl + 'comments/' + post.id + "?sort_order=" + sortOrderInitial + "&limit=10&offset=" + offset
        ).then(resp => {
            if (resp.status === 200) {
                let data = [];
                data = resp.data.results;
                if (resp.data.results?.length > 9) {
                    setHasMoreComments(true);
                } else {
                    setHasMoreComments(false);
                }
                data = [
                    ...data,
                    ...commentList
                ]
                if (sortOrder == "asc") {
                    const ascSortedData = data?.slice().sort((a, b) => new Date(a.created_on) - new Date(b.created_on));
                    setCommentList(ascSortedData);
                }
                if (sortOrder == "desc") {
                    const descSortedData = data?.slice().sort((a, b) => new Date(b.created_on) - new Date(a.created_on));
                    setCommentList(descSortedData);
                }
                setLoadingComments(false);
            } else {
                setLoadingComments(false);
            }
        }).catch(err => {
            setLoadingComments(false);
            tokenAuthorize(err?.response?.status);
            console.log(err)
        })
    }

    const addComment = (commentText, isPublic) => {
        return axios.post(
            serverUrl.ReflectionPost + '/comment',
            { reflection_id: post.id, comment: commentText, visibility: isPublic }
        ).then(resp => {
            if (resp.status === 200) {
                let str = sortOrder
                if (localStorage.getItem("sortOrder") != undefined) {
                    str = localStorage.getItem("sortOrder")
                    setSortOrder(str)
                }
                post.comments = post.comments + 1;
                let object = [{
                    "photo": userProfile?.photo,
                    "fullname": userProfile?.fullname,
                    "created_on": new Date(),
                    "guid": userProfile?.guid,
                    "reflection_comment_id": resp.data?.reflection_comment_id,
                    "user_id": resp.data?.user_id,
                    "comments": commentText,
                    "visibility": isPublic
                }];
                if (toggleComment == false) {
                    setCommentList([]);
                    setOffsetComments(0);
                    setToggleComment(true);
                    setLoadingComments(true);
                    getComments(offsetComments);
                } else {
                    if (str == "desc") {
                        if ((hasMoreComments == false || sortOrderInitial == "desc")) {
                            setCommentList([
                                ...object,
                                ...commentList
                            ]);
                        }
                    }
                    if (str == "asc") {
                        if (hasMoreComments == false || sortOrderInitial == "desc") {
                            setCommentList([
                                ...commentList,
                                ...object,
                            ]);
                        }
                    }
                }
                setComment('');
                // props.addComment && props.addComment(post.id);
            }
        }).catch((err) => {
            tokenAuthorize(err?.response?.status);
            console.log(err)
        })
    }

    const loadMoreComments = () => {
        setLoadingComments(true);
        let count = offsetComments + 10;
        setOffsetComments(offsetComments + 10);
        getComments(count);
    }

    const handleSort = (str) => {
        setSortOrder(str)
        localStorage.setItem("sortOrder", str)
        if (str == "asc") {
            const ascSortedData = commentList?.slice().sort((a, b) => new Date(a.created_on) - new Date(b.created_on));
            setCommentList(ascSortedData);
        }
        if (str == "desc") {
            const descSortedData = commentList?.slice().sort((a, b) => new Date(b.created_on) - new Date(a.created_on));
            setCommentList(descSortedData);
        }
    }

    const handlePrivatePublic = (data) => {
        if (isPublic != data) {
            setIsPublic(data)
        }
    }

    return (
        <div className="gap-4 pb-4" >
            <CardNew className={
                "flex bg-white relative overflow-hidden border flex-col cursor-pointer md:flex-row  "
                + (toggleComment ? "rounded-t-xl" : "rounded-xl")
            } onClick={() => isGuest ? history.push(isPublicProfileURL(post.id), { src: src, theme: profileTheme, userGuid: profile?.guid }, { state: { tabId } }) : history.push(isPublicProfileURL(post.id), { src: src, theme: profileTheme }, { state: { tabId } })}>
                {/* Image Section */}
                <div className="md:w-80 flex-shrink-0 cursor-pointer">
                    <img
                        src={(post.cover && (post.cover.length > 0)) ? post.cover : NO_IMAGE}
                        alt={post.title}
                        className="w-full h-80 object-cover max-h-64 md:max-h-full p-4 border30px"
                        onError={(e) => { e.target.src = NO_IMAGE }}
                    />
                </div>

                {/* Content Section */}
                <div className="p-4 md:pl-0 md:flex-grow flex flex-col justify-between cursor-pointer">
                    <div>
                        <div className="flex flex-col sm:flex-row justify-between mb-2">
                            <div className="flex gap-2">
                                {
                                    isGuest ?
                                        <img className="h-9 w-9 rounded-full"
                                            src={getProfilePic(profile.photo)} alt={profile.name}
                                        /> :
                                        <Link to={"/profile/" + profile.guid} >
                                            <img className="h-9 w-9 rounded-full"
                                                src={getProfilePic(profile.photo)} alt={profile.name}
                                            />
                                        </Link>
                                }
                                <div className="text-sm lightColor font-normal break-words flex-col">
                                    <h3 className="text-lg font-bold blackColor -mt-1">{post?.title}</h3>
                                    <div className="flex gap-1 items-center">
                                        by
                                        {
                                            isGuest ?
                                                <><p className="text-base font-semibold">{trimString(profile.name, 30)}</p></>
                                                :
                                                <Link to={"/profile/" + profile.guid} className="break-words nav-navigate">
                                                    <ActiveIconColor className="hover:underline text-base font-semibold">{trimString(profile.name, 30)}</ActiveIconColor>
                                                </Link>
                                        }
                                    </div>
                                </div>
                            </div>
                            <span className="lightColor text-sm flex">
                                {moment.utc(post.reflection_updated_on).local().startOf('seconds').fromNow()} ({convertDateFormat(post.reflection_updated_on)})
                            </span>
                        </div>
                        <p className=" text-base leading-relaxed mb-4">
                            <div className="text-viewer flex-1 text-sm lg:text-base break-words font-normal mb-3 container-multi overflow-wrap-break-word">
                                <RichTextReadMore
                                    htmlContent={removeIframe(post?.content)}
                                    maxLines={4}
                                    postId={post?.id}
                                    src={src}
                                    state={tabId}
                                    isPublicProfileURL={isPublicProfileURL}
                                />
                            </div>
                        </p>
                    </div>

                    <div className="mt-4 md:mt-6" onClick={(e) => e.stopPropagation()}>
                        {!isGuest && (
                            <ChatInput
                                message={comment}
                                setMessage={setComment}
                                addComment={addComment}
                                isPublic={isPublic}
                                handlePrivatePublic={handlePrivatePublic}
                            />
                        )}
                        <div className={`flex lex-1 md:flex-row items-center mt-2 px-2 lightColor text-sm ${!isGuest ? "cursor-pointer" : "pointer-events-none"}`} onClick={(e) => e.stopPropagation()}>
                            {
                                (post.likes.avatars.length > 0) && <AvatarGroup likesList={post.likes.avatars} />
                            }
                            <LikeComment
                                currentIsLiked={post.likes.is_like ? 1 : 0}
                                numLikes={post.likes.count}
                                numComments={post.comments} 
                                reflection_id={post.id}
                                isShowcase={true}
                                isPinned={true}
                                handleComment={() => { if (!isGuest) handleCommentClick() }}
                                handleLike={() => { if (!isGuest) likePost(post.likes.is_like ? 0 : 1) }}
                                readOnly={isGuest}
                            />
                        </div>
                    </div>
                </div>
            </CardNew>
            {toggleComment === true && <>
                <div
                    className={"block py-2 rounded-b-xl border-b border-r border-l backgroundColor8 blackColor"}
                    onClick={(e) => e.stopPropagation()}
                >
                    <div className={`px-5`}>
                        {post?.comments != 0 && (
                            <div className="flex flex-col sm:flex-row items-center justify-between">
                                <p className="text-base font-semibold blackColor">Comments ({post?.comments})</p>
                                {toggleComment == true && (
                                    <SortToggle onChange={handleSort} sortOrder={sortOrder} />
                                )}
                            </div>
                        )}
                        {toggleComment === true && (
                            <>
                                {commentList.length > 0
                                    ? commentList.map((comment, index) => (
                                        <Comment
                                            key={index}
                                            order={index}
                                            profilePic={comment.photo}
                                            username={comment.fullname}
                                            createdOn={comment.created_on}
                                            comment={comment.comments}
                                            userId={comment.user_id}
                                            isView={!isGuest}
                                            guID={comment.guid}
                                            isPrivate={comment.visibility}
                                            publicView={isGuest}
                                            deleteView={false}
                                        />
                                    ))
                                    : loadingComments === false && <p className="py-1">There is no comment yet.</p>
                                }
                            </>
                        )}
                    </div>

                    {loadingComments && (
                        <div className="grid grid-cols-1 h-10">
                            <div className="justify-center justify-self-center mt-1.5">
                                <Loading active={loadingComments} />
                            </div>
                        </div>
                    )}

                    {toggleComment && hasMoreComments && (
                        <div className="grid grid-cols-1 h-14 mt-3">
                            <div className="justify-center justify-self-center">
                                <ButtonCommonTopNew className="px-5 border p-2 text-sm rounded-lg cursor-pointer" onClick={loadMoreComments}>
                                    Load More
                                </ButtonCommonTopNew>
                            </div>
                        </div>
                    )}
                </div>
            </>}
        </div>
    )
}

PublicCardPostNew.propTypes = {
    post: PropTypes.object,
    profile: PropTypes.object,
    tabId: PropTypes.string,
    isGuest: PropTypes.bool,
    guestCode: PropTypes.string,
    profileTheme: PropTypes.object,
    likePost: PropTypes.func,
    addComment: PropTypes.func,
}

export default PublicCardPostNew
